import { $black } from './commonColors';

const yellow = '#FFCC00';

const primaryMain = $black;
const primaryMainOpacity = 'rgba(0, 0, 0, 0.9)';
const secondaryMain = yellow;
const secondaryMainOpacity = 'rgba(255, 204, 0, 0.5)';
const secondaryLight = yellow;
const tertiaryMain = '#3E3E3E';

export const palette = {
  primaryMain,
  primaryMainOpacity,
  primaryText: primaryMain,
  secondaryMain,
  secondaryMainOpacity,
  secondaryLight,
  secondaryText: primaryMain,
  tertiaryMain,
  logoContainerMobile: {
    height: 30,
    marginBottom: 20
  },
  formNavBar: {
    currentStepButtonTextColor: tertiaryMain
  }
};
